import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/rta-label-white.png")